import type { EventLog, GetEventLogsRequest } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type EventLogStore = StoreEntity<
  EventLog,
  'id',
  GetEventLogsRequest,
  File,
  null
>;

export const useEventLogStore = apiStoreFactory<
  EventLogStore['entity'],
  EventLogStore['id'],
  EventLogStore['filter'],
  EventLogStore['createInput'],
  EventLogStore['updateInput']
>(
  STORE.EVENT_LOG,
  { entityIdKey: 'id' },
  {
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getEventLogsRaw(filter, { signal });
    },
  },
);
